import { pricing } from './pricing'

export interface PurchaseEvent {
  name: string
  city: string
  offer: string
}

const buyers: { name: string; city: string }[] = [
  { name: 'Mariana G.', city: 'Buenos Aires' },
  { name: 'Claudia P.', city: 'Córdoba' },
  { name: 'Sofía M.', city: 'Rosario' },
  { name: 'Gabriela L.', city: 'La Plata' },
  { name: 'Verónica A.', city: 'Mar del Plata' },
  { name: 'Roberto D.', city: 'Mendoza' },
  { name: 'Silvina C.', city: 'Santa Fe' },
  { name: 'Patricia R.', city: 'San Miguel de Tucumán' },
  { name: 'Norberto S.', city: 'Bahía Blanca' },
  { name: 'Lorena F.', city: 'Salta' },
  { name: 'Andrea V.', city: 'Neuquén' },
  { name: 'Diego M.', city: 'Quilmes' },
  { name: 'Carolina B.', city: 'Paraná' },
  { name: 'Marcelo T.', city: 'Corrientes' },
  { name: 'Alejandra N.', city: 'San Juan' },
  { name: 'Romina E.', city: 'Posadas' },
  { name: 'Estela H.', city: 'Río Cuarto' },
  { name: 'Fernanda Q.', city: 'Resistencia' },
]

const offers: string[] = [
  `Mega Pack Acompañante — ${pricing.main}`,
  `Mega Pack + Complemento opcional — ${pricing.upsell} extra`,
]

export function randomPurchase(): PurchaseEvent {
  const buyer = buyers[Math.floor(Math.random() * buyers.length)]
  const offer = offers[Math.floor(Math.random() * offers.length)]
  return { ...buyer, offer }
}
